<template>
  <div :class="b('container')">
    <slot />
  </div>
</template>

<script src="./scripts.js" />

<style module src="./styles.scss" lang="scss" />
